import { environment } from '../../../environments/environment';

export class ENDPOINTS {
  public static HOST = environment.host;
  public static HOST_COGNITO = environment.host_cognito
    .concat('/login?response_type=')
    .concat(environment.response_type)
    .concat('&client_id=')
    .concat(environment.client_id)
    .concat('&redirect_uri=')
    .concat(encodeURI(environment.redirect_uri));

  public static HOST_COGNITO_LOGOUT = environment.host_cognito
    .concat('/logout?response_type=')
    .concat(environment.response_type)
    .concat('&client_id=')
    .concat(environment.client_id)
    .concat('&redirect_uri=')
    .concat(encodeURI(environment.redirect_uri_logout));
}

export class RECAPTCHA {
  public static SECRET_KEY = environment.site_key;
}

export class PERFILES {
  public static ADMINISTRADOR = 1;
  public static EDITOR = 2;
  public static PUBLICO = 3;
}

export class PERFILESUSUARIO {
  public static COORDINADOR_ADMINISTRADOR = 1;
  public static COORDINADOR_EDITOR = 2;
  public static EMPRESA_EDITOR = 3;
  public static PUBLICO = 4;
}
